/**
 *  @class
 *  @function TermsCheckbox
 */
if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.append = this.dataset.append;
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`);
      this.privacy_checkbox = this.querySelector(`#Privacy${this.append}`);
      this.returns_checkbox = this.querySelector(`#ReturnPolicy${this.append}`);
      this.checkout_button = this.parentNode.querySelector('.button.checkout-button');

      // Ustawiamy domyślne komunikaty
      const setValidity = (checkbox, message) => {
        if (checkbox) checkbox.setCustomValidity(checkbox.checked ? '' : message);
      };
      if (this.terms_checkbox) {
        this.terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
        this.terms_checkbox.addEventListener('change', () => setValidity(this.terms_checkbox, theme.strings.requiresTerms));
      }
      if (this.privacy_checkbox) {
        this.privacy_checkbox.setCustomValidity(theme.strings.requiresPrivacyPolicy);
        this.privacy_checkbox.addEventListener('change', () => setValidity(this.privacy_checkbox, theme.strings.requiresPrivacyPolicy));
      }
      if (this.returns_checkbox) {
        this.returns_checkbox.setCustomValidity(theme.strings.requiresReturnPolicy);
        this.returns_checkbox.addEventListener('change', () => setValidity(this.returns_checkbox, theme.strings.requiresReturnPolicy));
      }

        this.checkout_button.addEventListener('click', (e) => {
          // 1. Terms (AGB)
          if (this.terms_checkbox && !this.terms_checkbox.checked) {
            this.terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
            this.terms_checkbox.reportValidity();
            this.terms_checkbox.focus();
            e.preventDefault();
            return;
          }
          // 2. ReturnPolicy (Zwroty)
          if (this.returns_checkbox && !this.returns_checkbox.checked) {
            this.returns_checkbox.setCustomValidity(theme.strings.requiresReturnPolicy);
            this.returns_checkbox.reportValidity();
            this.returns_checkbox.focus();
            e.preventDefault();
            return;
          }
          // 3. Privacy
          if (this.privacy_checkbox && !this.privacy_checkbox.checked) {
            this.privacy_checkbox.setCustomValidity(theme.strings.requiresPrivacyPolicy);
            this.privacy_checkbox.reportValidity();
            this.privacy_checkbox.focus();
            e.preventDefault();
            return;
          }
        });

      
    }
  }
  customElements.define('terms-checkbox', TermsCheckbox);
}
